import type { GuideStep } from '../types';

export const SHORTCUTS_STEPS: GuideStep[] = [
  {
    id: 'shortcuts-1',
    page: 'index',
    section: 'shortcuts',
    target: 'topbar-undo',
    title: { sv: 'Ångra & Gör om', en: 'Undo & Redo' },
    body: {
      sv: 'Ctrl+Z ångrar senaste åtgärden, Ctrl+Y (eller Ctrl+Shift+Z) gör om. Historiken sparar 50 steg.',
      en: 'Ctrl+Z undoes, Ctrl+Y (or Ctrl+Shift+Z) redoes. History keeps 50 steps.',
    },
    placement: 'bottom',
    interests: ['shortcuts'],
    order: 1,
  },
  {
    id: 'shortcuts-2',
    page: 'index',
    section: 'shortcuts',
    target: 'canvas',
    title: { sv: 'Spara & ta bort', en: 'Save & delete' },
    body: {
      sv: 'Ctrl+S sparar. Delete tar bort markerat. Esc avmarkerar eller stänger dialoger.',
      en: 'Ctrl+S saves. Delete removes selection. Esc deselects or closes dialogs.',
    },
    placement: 'auto',
    interests: ['shortcuts'],
    order: 2,
  },
  {
    id: 'shortcuts-3',
    page: 'index',
    section: 'shortcuts',
    target: 'canvas',
    title: { sv: 'Panorering & zoom', en: 'Pan & zoom' },
    body: {
      sv: 'Space + drag panorerar. Ctrl+scroll zoomar. Ctrl+0 återställer zoom. Ctrl+1 zoomar till hela workflowet.',
      en: 'Space + drag pans. Ctrl+scroll zooms. Ctrl+0 resets zoom. Ctrl+1 zooms to fit.',
    },
    placement: 'auto',
    interests: ['shortcuts'],
    order: 3,
  },
];
